































import Vue from "vue";
import moment from "moment";
import { mapState, mapGetters } from "vuex";

export default Vue.extend({
  name: "CancelAccount",
  props: {
    showEditor: Boolean,
  },
  data() {
    return {
      cancellationOption: "endOfPeriod",
    };
  },
  computed: {
    ...mapState("billing", ["billingAccount"]),
    showModal(): any {
      return this.showEditor;
    },
    today() {
      return moment().format("MMM D, YYYY");
    },
    billingAccountEndDate() {
      let context = this as any;
      return context.billingAccount ? moment(context.billingAccount.currentPlanEndDate).format("MMM D, YYYY") : "";
    },
  },
  watch: {
    showModal(newVal) {},
  },
  methods: {
    handleClickCancellationOption(name) {
      this.cancellationOption = name;
    },
    handleCancel() {
      this.$emit("cancel");
    },
    handleSave(event) {
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;

      let context = this;
      context.$store
        .dispatch("billing/cancelAccount", {
          immediately: context.cancellationOption === "immediately",
        })
        .then(() => {
          context.$Notice.success({
            title: "Account canceled.",
            desc: "Success! ",
          });

          location.reload();
        })
        .finally(() => {
          context.$emit("cancel");
          target.disabled = false;
        });
    },
  },
});
